/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The reason a rubric row is locked.
 */
export const RubricLockReason = /* #__PURE__ */ parsers.exactly('auto_test', 'auto_test_2');
